// Generated from FHIRPath.g4 by ANTLR 4.7.1
// jshint ignore: start
var antlr4 = require('antlr4/index');


var serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
    "\u0002?\u01f1\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004",
    "\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t",
    "\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004",
    "\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010",
    "\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013",
    "\u0004\u0014\t\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017",
    "\t\u0017\u0004\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a",
    "\u0004\u001b\t\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e",
    "\t\u001e\u0004\u001f\t\u001f\u0004 \t \u0004!\t!\u0004\"\t\"\u0004#",
    "\t#\u0004$\t$\u0004%\t%\u0004&\t&\u0004\'\t\'\u0004(\t(\u0004)\t)\u0004",
    "*\t*\u0004+\t+\u0004,\t,\u0004-\t-\u0004.\t.\u0004/\t/\u00040\t0\u0004",
    "1\t1\u00042\t2\u00043\t3\u00044\t4\u00045\t5\u00046\t6\u00047\t7\u0004",
    "8\t8\u00049\t9\u0004:\t:\u0004;\t;\u0004<\t<\u0004=\t=\u0004>\t>\u0004",
    "?\t?\u0004@\t@\u0004A\tA\u0004B\tB\u0003\u0002\u0003\u0002\u0003\u0003",
    "\u0003\u0003\u0003\u0004\u0003\u0004\u0003\u0005\u0003\u0005\u0003\u0006",
    "\u0003\u0006\u0003\u0007\u0003\u0007\u0003\b\u0003\b\u0003\t\u0003\t",
    "\u0003\t\u0003\t\u0003\n\u0003\n\u0003\n\u0003\n\u0003\u000b\u0003\u000b",
    "\u0003\f\u0003\f\u0003\r\u0003\r\u0003\r\u0003\u000e\u0003\u000e\u0003",
    "\u000f\u0003\u000f\u0003\u0010\u0003\u0010\u0003\u0010\u0003\u0011\u0003",
    "\u0011\u0003\u0011\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0013\u0003",
    "\u0013\u0003\u0014\u0003\u0014\u0003\u0015\u0003\u0015\u0003\u0015\u0003",
    "\u0016\u0003\u0016\u0003\u0016\u0003\u0017\u0003\u0017\u0003\u0017\u0003",
    "\u0018\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0018\u0003",
    "\u0018\u0003\u0018\u0003\u0018\u0003\u0019\u0003\u0019\u0003\u0019\u0003",
    "\u0019\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001b\u0003\u001b\u0003",
    "\u001b\u0003\u001b\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003",
    "\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001d\u0003\u001d\u0003",
    "\u001e\u0003\u001e\u0003\u001f\u0003\u001f\u0003 \u0003 \u0003!\u0003",
    "!\u0003!\u0003!\u0003!\u0003\"\u0003\"\u0003\"\u0003\"\u0003\"\u0003",
    "\"\u0003#\u0003#\u0003$\u0003$\u0003$\u0003$\u0003$\u0003$\u0003%\u0003",
    "%\u0003&\u0003&\u0003&\u0003&\u0003&\u0003\'\u0003\'\u0003\'\u0003\'",
    "\u0003\'\u0003\'\u0003(\u0003(\u0003(\u0003(\u0003(\u0003)\u0003)\u0003",
    ")\u0003)\u0003*\u0003*\u0003*\u0003*\u0003*\u0003+\u0003+\u0003+\u0003",
    "+\u0003+\u0003+\u0003+\u0003,\u0003,\u0003,\u0003,\u0003,\u0003,\u0003",
    ",\u0003-\u0003-\u0003-\u0003-\u0003-\u0003-\u0003-\u0003-\u0003-\u0003",
    "-\u0003-\u0003-\u0003.\u0003.\u0003.\u0003.\u0003.\u0003.\u0003/\u0003",
    "/\u0003/\u0003/\u0003/\u0003/\u0003/\u00030\u00030\u00030\u00030\u0003",
    "0\u00030\u00031\u00031\u00031\u00031\u00031\u00032\u00032\u00032\u0003",
    "2\u00032\u00032\u00033\u00033\u00033\u00033\u00033\u00033\u00033\u0003",
    "3\u00034\u00034\u00034\u00034\u00034\u00034\u00034\u00034\u00035\u0003",
    "5\u00035\u00035\u00035\u00035\u00035\u00035\u00035\u00035\u00035\u0003",
    "5\u00035\u00036\u00036\u00036\u00036\u00036\u00036\u00036\u00036\u0003",
    "6\u00036\u00036\u00036\u00036\u00056\u0171\n6\u00056\u0173\n6\u0005",
    "6\u0175\n6\u00036\u00056\u0178\n6\u00037\u00037\u00037\u00037\u0003",
    "8\u00038\u00038\u00038\u00038\u00038\u00038\u00038\u00038\u00038\u0006",
    "8\u0188\n8\r8\u000e8\u0189\u00058\u018c\n8\u00058\u018e\n8\u00058\u0190",
    "\n8\u00038\u00038\u00038\u00038\u00038\u00038\u00038\u00058\u0199\n",
    "8\u00039\u00059\u019c\n9\u00039\u00079\u019f\n9\f9\u000e9\u01a2\u000b",
    "9\u0003:\u0003:\u0003:\u0007:\u01a7\n:\f:\u000e:\u01aa\u000b:\u0003",
    ":\u0003:\u0003;\u0003;\u0003;\u0007;\u01b1\n;\f;\u000e;\u01b4\u000b",
    ";\u0003;\u0003;\u0003<\u0006<\u01b9\n<\r<\u000e<\u01ba\u0003<\u0003",
    "<\u0006<\u01bf\n<\r<\u000e<\u01c0\u0005<\u01c3\n<\u0003=\u0006=\u01c6",
    "\n=\r=\u000e=\u01c7\u0003=\u0003=\u0003>\u0003>\u0003>\u0003>\u0007",
    ">\u01d0\n>\f>\u000e>\u01d3\u000b>\u0003>\u0003>\u0003>\u0003>\u0003",
    ">\u0003?\u0003?\u0003?\u0003?\u0007?\u01de\n?\f?\u000e?\u01e1\u000b",
    "?\u0003?\u0003?\u0003@\u0003@\u0003@\u0005@\u01e8\n@\u0003A\u0003A\u0003",
    "A\u0003A\u0003A\u0003A\u0003B\u0003B\u0003\u01d1\u0002C\u0003\u0003",
    "\u0005\u0004\u0007\u0005\t\u0006\u000b\u0007\r\b\u000f\t\u0011\n\u0013",
    "\u000b\u0015\f\u0017\r\u0019\u000e\u001b\u000f\u001d\u0010\u001f\u0011",
    "!\u0012#\u0013%\u0014\'\u0015)\u0016+\u0017-\u0018/\u00191\u001a3\u001b",
    "5\u001c7\u001d9\u001e;\u001f= ?!A\"C#E$G%I&K\'M(O)Q*S+U,W-Y.[/]0_1a",
    "2c3e4g5i6k7m8o\u0002q9s:u;w<y={>}?\u007f\u0002\u0081\u0002\u0083\u0002",
    "\u0003\u0002\f\u0003\u00022;\u0004\u0002--//\u0005\u0002C\\aac|\u0006",
    "\u00022;C\\aac|\u0004\u0002$$^^\u0003\u0002))\u0005\u0002\u000b\f\u000f",
    "\u000f\"\"\u0004\u0002\f\f\u000f\u000f\n\u0002$$))11^^hhppttvv\u0005",
    "\u00022;CHch\u0002\u0202\u0002\u0003\u0003\u0002\u0002\u0002\u0002\u0005",
    "\u0003\u0002\u0002\u0002\u0002\u0007\u0003\u0002\u0002\u0002\u0002\t",
    "\u0003\u0002\u0002\u0002\u0002\u000b\u0003\u0002\u0002\u0002\u0002\r",
    "\u0003\u0002\u0002\u0002\u0002\u000f\u0003\u0002\u0002\u0002\u0002\u0011",
    "\u0003\u0002\u0002\u0002\u0002\u0013\u0003\u0002\u0002\u0002\u0002\u0015",
    "\u0003\u0002\u0002\u0002\u0002\u0017\u0003\u0002\u0002\u0002\u0002\u0019",
    "\u0003\u0002\u0002\u0002\u0002\u001b\u0003\u0002\u0002\u0002\u0002\u001d",
    "\u0003\u0002\u0002\u0002\u0002\u001f\u0003\u0002\u0002\u0002\u0002!",
    "\u0003\u0002\u0002\u0002\u0002#\u0003\u0002\u0002\u0002\u0002%\u0003",
    "\u0002\u0002\u0002\u0002\'\u0003\u0002\u0002\u0002\u0002)\u0003\u0002",
    "\u0002\u0002\u0002+\u0003\u0002\u0002\u0002\u0002-\u0003\u0002\u0002",
    "\u0002\u0002/\u0003\u0002\u0002\u0002\u00021\u0003\u0002\u0002\u0002",
    "\u00023\u0003\u0002\u0002\u0002\u00025\u0003\u0002\u0002\u0002\u0002",
    "7\u0003\u0002\u0002\u0002\u00029\u0003\u0002\u0002\u0002\u0002;\u0003",
    "\u0002\u0002\u0002\u0002=\u0003\u0002\u0002\u0002\u0002?\u0003\u0002",
    "\u0002\u0002\u0002A\u0003\u0002\u0002\u0002\u0002C\u0003\u0002\u0002",
    "\u0002\u0002E\u0003\u0002\u0002\u0002\u0002G\u0003\u0002\u0002\u0002",
    "\u0002I\u0003\u0002\u0002\u0002\u0002K\u0003\u0002\u0002\u0002\u0002",
    "M\u0003\u0002\u0002\u0002\u0002O\u0003\u0002\u0002\u0002\u0002Q\u0003",
    "\u0002\u0002\u0002\u0002S\u0003\u0002\u0002\u0002\u0002U\u0003\u0002",
    "\u0002\u0002\u0002W\u0003\u0002\u0002\u0002\u0002Y\u0003\u0002\u0002",
    "\u0002\u0002[\u0003\u0002\u0002\u0002\u0002]\u0003\u0002\u0002\u0002",
    "\u0002_\u0003\u0002\u0002\u0002\u0002a\u0003\u0002\u0002\u0002\u0002",
    "c\u0003\u0002\u0002\u0002\u0002e\u0003\u0002\u0002\u0002\u0002g\u0003",
    "\u0002\u0002\u0002\u0002i\u0003\u0002\u0002\u0002\u0002k\u0003\u0002",
    "\u0002\u0002\u0002m\u0003\u0002\u0002\u0002\u0002q\u0003\u0002\u0002",
    "\u0002\u0002s\u0003\u0002\u0002\u0002\u0002u\u0003\u0002\u0002\u0002",
    "\u0002w\u0003\u0002\u0002\u0002\u0002y\u0003\u0002\u0002\u0002\u0002",
    "{\u0003\u0002\u0002\u0002\u0002}\u0003\u0002\u0002\u0002\u0003\u0085",
    "\u0003\u0002\u0002\u0002\u0005\u0087\u0003\u0002\u0002\u0002\u0007\u0089",
    "\u0003\u0002\u0002\u0002\t\u008b\u0003\u0002\u0002\u0002\u000b\u008d",
    "\u0003\u0002\u0002\u0002\r\u008f\u0003\u0002\u0002\u0002\u000f\u0091",
    "\u0003\u0002\u0002\u0002\u0011\u0093\u0003\u0002\u0002\u0002\u0013\u0097",
    "\u0003\u0002\u0002\u0002\u0015\u009b\u0003\u0002\u0002\u0002\u0017\u009d",
    "\u0003\u0002\u0002\u0002\u0019\u009f\u0003\u0002\u0002\u0002\u001b\u00a2",
    "\u0003\u0002\u0002\u0002\u001d\u00a4\u0003\u0002\u0002\u0002\u001f\u00a6",
    "\u0003\u0002\u0002\u0002!\u00a9\u0003\u0002\u0002\u0002#\u00ac\u0003",
    "\u0002\u0002\u0002%\u00af\u0003\u0002\u0002\u0002\'\u00b1\u0003\u0002",
    "\u0002\u0002)\u00b3\u0003\u0002\u0002\u0002+\u00b6\u0003\u0002\u0002",
    "\u0002-\u00b9\u0003\u0002\u0002\u0002/\u00bc\u0003\u0002\u0002\u0002",
    "1\u00c5\u0003\u0002\u0002\u00023\u00c9\u0003\u0002\u0002\u00025\u00cc",
    "\u0003\u0002\u0002\u00027\u00d0\u0003\u0002\u0002\u00029\u00d8\u0003",
    "\u0002\u0002\u0002;\u00da\u0003\u0002\u0002\u0002=\u00dc\u0003\u0002",
    "\u0002\u0002?\u00de\u0003\u0002\u0002\u0002A\u00e0\u0003\u0002\u0002",
    "\u0002C\u00e5\u0003\u0002\u0002\u0002E\u00eb\u0003\u0002\u0002\u0002",
    "G\u00ed\u0003\u0002\u0002\u0002I\u00f3\u0003\u0002\u0002\u0002K\u00f5",
    "\u0003\u0002\u0002\u0002M\u00fa\u0003\u0002\u0002\u0002O\u0100\u0003",
    "\u0002\u0002\u0002Q\u0105\u0003\u0002\u0002\u0002S\u0109\u0003\u0002",
    "\u0002\u0002U\u010e\u0003\u0002\u0002\u0002W\u0115\u0003\u0002\u0002",
    "\u0002Y\u011c\u0003\u0002\u0002\u0002[\u0128\u0003\u0002\u0002\u0002",
    "]\u012e\u0003\u0002\u0002\u0002_\u0135\u0003\u0002\u0002\u0002a\u013b",
    "\u0003\u0002\u0002\u0002c\u0140\u0003\u0002\u0002\u0002e\u0146\u0003",
    "\u0002\u0002\u0002g\u014e\u0003\u0002\u0002\u0002i\u0156\u0003\u0002",
    "\u0002\u0002k\u0163\u0003\u0002\u0002\u0002m\u0179\u0003\u0002\u0002",
    "\u0002o\u017d\u0003\u0002\u0002\u0002q\u019b\u0003\u0002\u0002\u0002",
    "s\u01a3\u0003\u0002\u0002\u0002u\u01ad\u0003\u0002\u0002\u0002w\u01b8",
    "\u0003\u0002\u0002\u0002y\u01c5\u0003\u0002\u0002\u0002{\u01cb\u0003",
    "\u0002\u0002\u0002}\u01d9\u0003\u0002\u0002\u0002\u007f\u01e4\u0003",
    "\u0002\u0002\u0002\u0081\u01e9\u0003\u0002\u0002\u0002\u0083\u01ef\u0003",
    "\u0002\u0002\u0002\u0085\u0086\u00070\u0002\u0002\u0086\u0004\u0003",
    "\u0002\u0002\u0002\u0087\u0088\u0007]\u0002\u0002\u0088\u0006\u0003",
    "\u0002\u0002\u0002\u0089\u008a\u0007_\u0002\u0002\u008a\b\u0003\u0002",
    "\u0002\u0002\u008b\u008c\u0007-\u0002\u0002\u008c\n\u0003\u0002\u0002",
    "\u0002\u008d\u008e\u0007/\u0002\u0002\u008e\f\u0003\u0002\u0002\u0002",
    "\u008f\u0090\u0007,\u0002\u0002\u0090\u000e\u0003\u0002\u0002\u0002",
    "\u0091\u0092\u00071\u0002\u0002\u0092\u0010\u0003\u0002\u0002\u0002",
    "\u0093\u0094\u0007f\u0002\u0002\u0094\u0095\u0007k\u0002\u0002\u0095",
    "\u0096\u0007x\u0002\u0002\u0096\u0012\u0003\u0002\u0002\u0002\u0097",
    "\u0098\u0007o\u0002\u0002\u0098\u0099\u0007q\u0002\u0002\u0099\u009a",
    "\u0007f\u0002\u0002\u009a\u0014\u0003\u0002\u0002\u0002\u009b\u009c",
    "\u0007(\u0002\u0002\u009c\u0016\u0003\u0002\u0002\u0002\u009d\u009e",
    "\u0007~\u0002\u0002\u009e\u0018\u0003\u0002\u0002\u0002\u009f\u00a0",
    "\u0007>\u0002\u0002\u00a0\u00a1\u0007?\u0002\u0002\u00a1\u001a\u0003",
    "\u0002\u0002\u0002\u00a2\u00a3\u0007>\u0002\u0002\u00a3\u001c\u0003",
    "\u0002\u0002\u0002\u00a4\u00a5\u0007@\u0002\u0002\u00a5\u001e\u0003",
    "\u0002\u0002\u0002\u00a6\u00a7\u0007@\u0002\u0002\u00a7\u00a8\u0007",
    "?\u0002\u0002\u00a8 \u0003\u0002\u0002\u0002\u00a9\u00aa\u0007k\u0002",
    "\u0002\u00aa\u00ab\u0007u\u0002\u0002\u00ab\"\u0003\u0002\u0002\u0002",
    "\u00ac\u00ad\u0007c\u0002\u0002\u00ad\u00ae\u0007u\u0002\u0002\u00ae",
    "$\u0003\u0002\u0002\u0002\u00af\u00b0\u0007?\u0002\u0002\u00b0&\u0003",
    "\u0002\u0002\u0002\u00b1\u00b2\u0007\u0080\u0002\u0002\u00b2(\u0003",
    "\u0002\u0002\u0002\u00b3\u00b4\u0007#\u0002\u0002\u00b4\u00b5\u0007",
    "?\u0002\u0002\u00b5*\u0003\u0002\u0002\u0002\u00b6\u00b7\u0007#\u0002",
    "\u0002\u00b7\u00b8\u0007\u0080\u0002\u0002\u00b8,\u0003\u0002\u0002",
    "\u0002\u00b9\u00ba\u0007k\u0002\u0002\u00ba\u00bb\u0007p\u0002\u0002",
    "\u00bb.\u0003\u0002\u0002\u0002\u00bc\u00bd\u0007e\u0002\u0002\u00bd",
    "\u00be\u0007q\u0002\u0002\u00be\u00bf\u0007p\u0002\u0002\u00bf\u00c0",
    "\u0007v\u0002\u0002\u00c0\u00c1\u0007c\u0002\u0002\u00c1\u00c2\u0007",
    "k\u0002\u0002\u00c2\u00c3\u0007p\u0002\u0002\u00c3\u00c4\u0007u\u0002",
    "\u0002\u00c40\u0003\u0002\u0002\u0002\u00c5\u00c6\u0007c\u0002\u0002",
    "\u00c6\u00c7\u0007p\u0002\u0002\u00c7\u00c8\u0007f\u0002\u0002\u00c8",
    "2\u0003\u0002\u0002\u0002\u00c9\u00ca\u0007q\u0002\u0002\u00ca\u00cb",
    "\u0007t\u0002\u0002\u00cb4\u0003\u0002\u0002\u0002\u00cc\u00cd\u0007",
    "z\u0002\u0002\u00cd\u00ce\u0007q\u0002\u0002\u00ce\u00cf\u0007t\u0002",
    "\u0002\u00cf6\u0003\u0002\u0002\u0002\u00d0\u00d1\u0007k\u0002\u0002",
    "\u00d1\u00d2\u0007o\u0002\u0002\u00d2\u00d3\u0007r\u0002\u0002\u00d3",
    "\u00d4\u0007n\u0002\u0002\u00d4\u00d5\u0007k\u0002\u0002\u00d5\u00d6",
    "\u0007g\u0002\u0002\u00d6\u00d7\u0007u\u0002\u0002\u00d78\u0003\u0002",
    "\u0002\u0002\u00d8\u00d9\u0007*\u0002\u0002\u00d9:\u0003\u0002\u0002",
    "\u0002\u00da\u00db\u0007+\u0002\u0002\u00db<\u0003\u0002\u0002\u0002",
    "\u00dc\u00dd\u0007}\u0002\u0002\u00dd>\u0003\u0002\u0002\u0002\u00de",
    "\u00df\u0007\u007f\u0002\u0002\u00df@\u0003\u0002\u0002\u0002\u00e0",
    "\u00e1\u0007v\u0002\u0002\u00e1\u00e2\u0007t\u0002\u0002\u00e2\u00e3",
    "\u0007w\u0002\u0002\u00e3\u00e4\u0007g\u0002\u0002\u00e4B\u0003\u0002",
    "\u0002\u0002\u00e5\u00e6\u0007h\u0002\u0002\u00e6\u00e7\u0007c\u0002",
    "\u0002\u00e7\u00e8\u0007n\u0002\u0002\u00e8\u00e9\u0007u\u0002\u0002",
    "\u00e9\u00ea\u0007g\u0002\u0002\u00eaD\u0003\u0002\u0002\u0002\u00eb",
    "\u00ec\u0007\'\u0002\u0002\u00ecF\u0003\u0002\u0002\u0002\u00ed\u00ee",
    "\u0007&\u0002\u0002\u00ee\u00ef\u0007v\u0002\u0002\u00ef\u00f0\u0007",
    "j\u0002\u0002\u00f0\u00f1\u0007k\u0002\u0002\u00f1\u00f2\u0007u\u0002",
    "\u0002\u00f2H\u0003\u0002\u0002\u0002\u00f3\u00f4\u0007.\u0002\u0002",
    "\u00f4J\u0003\u0002\u0002\u0002\u00f5\u00f6\u0007{\u0002\u0002\u00f6",
    "\u00f7\u0007g\u0002\u0002\u00f7\u00f8\u0007c\u0002\u0002\u00f8\u00f9",
    "\u0007t\u0002\u0002\u00f9L\u0003\u0002\u0002\u0002\u00fa\u00fb\u0007",
    "o\u0002\u0002\u00fb\u00fc\u0007q\u0002\u0002\u00fc\u00fd\u0007p\u0002",
    "\u0002\u00fd\u00fe\u0007v\u0002\u0002\u00fe\u00ff\u0007j\u0002\u0002",
    "\u00ffN\u0003\u0002\u0002\u0002\u0100\u0101\u0007y\u0002\u0002\u0101",
    "\u0102\u0007g\u0002\u0002\u0102\u0103\u0007g\u0002\u0002\u0103\u0104",
    "\u0007m\u0002\u0002\u0104P\u0003\u0002\u0002\u0002\u0105\u0106\u0007",
    "f\u0002\u0002\u0106\u0107\u0007c\u0002\u0002\u0107\u0108\u0007{\u0002",
    "\u0002\u0108R\u0003\u0002\u0002\u0002\u0109\u010a\u0007j\u0002\u0002",
    "\u010a\u010b\u0007q\u0002\u0002\u010b\u010c\u0007w\u0002\u0002\u010c",
    "\u010d\u0007t\u0002\u0002\u010dT\u0003\u0002\u0002\u0002\u010e\u010f",
    "\u0007o\u0002\u0002\u010f\u0110\u0007k\u0002\u0002\u0110\u0111\u0007",
    "p\u0002\u0002\u0111\u0112\u0007w\u0002\u0002\u0112\u0113\u0007v\u0002",
    "\u0002\u0113\u0114\u0007g\u0002\u0002\u0114V\u0003\u0002\u0002\u0002",
    "\u0115\u0116\u0007u\u0002\u0002\u0116\u0117\u0007g\u0002\u0002\u0117",
    "\u0118\u0007e\u0002\u0002\u0118\u0119\u0007q\u0002\u0002\u0119\u011a",
    "\u0007p\u0002\u0002\u011a\u011b\u0007f\u0002\u0002\u011bX\u0003\u0002",
    "\u0002\u0002\u011c\u011d\u0007o\u0002\u0002\u011d\u011e\u0007k\u0002",
    "\u0002\u011e\u011f\u0007n\u0002\u0002\u011f\u0120\u0007n\u0002\u0002",
    "\u0120\u0121\u0007k\u0002\u0002\u0121\u0122\u0007u\u0002\u0002\u0122",
    "\u0123\u0007g\u0002\u0002\u0123\u0124\u0007e\u0002\u0002\u0124\u0125",
    "\u0007q\u0002\u0002\u0125\u0126\u0007p\u0002\u0002\u0126\u0127\u0007",
    "f\u0002\u0002\u0127Z\u0003\u0002\u0002\u0002\u0128\u0129\u0007{\u0002",
    "\u0002\u0129\u012a\u0007g\u0002\u0002\u012a\u012b\u0007c\u0002\u0002",
    "\u012b\u012c\u0007t\u0002\u0002\u012c\u012d\u0007u\u0002\u0002\u012d",
    "\\\u0003\u0002\u0002\u0002\u012e\u012f\u0007o\u0002\u0002\u012f\u0130",
    "\u0007q\u0002\u0002\u0130\u0131\u0007p\u0002\u0002\u0131\u0132\u0007",
    "v\u0002\u0002\u0132\u0133\u0007j\u0002\u0002\u0133\u0134\u0007u\u0002",
    "\u0002\u0134^\u0003\u0002\u0002\u0002\u0135\u0136\u0007y\u0002\u0002",
    "\u0136\u0137\u0007g\u0002\u0002\u0137\u0138\u0007g\u0002\u0002\u0138",
    "\u0139\u0007m\u0002\u0002\u0139\u013a\u0007u\u0002\u0002\u013a`\u0003",
    "\u0002\u0002\u0002\u013b\u013c\u0007f\u0002\u0002\u013c\u013d\u0007",
    "c\u0002\u0002\u013d\u013e\u0007{\u0002\u0002\u013e\u013f\u0007u\u0002",
    "\u0002\u013fb\u0003\u0002\u0002\u0002\u0140\u0141\u0007j\u0002\u0002",
    "\u0141\u0142\u0007q\u0002\u0002\u0142\u0143\u0007w\u0002\u0002\u0143",
    "\u0144\u0007t\u0002\u0002\u0144\u0145\u0007u\u0002\u0002\u0145d\u0003",
    "\u0002\u0002\u0002\u0146\u0147\u0007o\u0002\u0002\u0147\u0148\u0007",
    "k\u0002\u0002\u0148\u0149\u0007p\u0002\u0002\u0149\u014a\u0007w\u0002",
    "\u0002\u014a\u014b\u0007v\u0002\u0002\u014b\u014c\u0007g\u0002\u0002",
    "\u014c\u014d\u0007u\u0002\u0002\u014df\u0003\u0002\u0002\u0002\u014e",
    "\u014f\u0007u\u0002\u0002\u014f\u0150\u0007g\u0002\u0002\u0150\u0151",
    "\u0007e\u0002\u0002\u0151\u0152\u0007q\u0002\u0002\u0152\u0153\u0007",
    "p\u0002\u0002\u0153\u0154\u0007f\u0002\u0002\u0154\u0155\u0007u\u0002",
    "\u0002\u0155h\u0003\u0002\u0002\u0002\u0156\u0157\u0007o\u0002\u0002",
    "\u0157\u0158\u0007k\u0002\u0002\u0158\u0159\u0007n\u0002\u0002\u0159",
    "\u015a\u0007n\u0002\u0002\u015a\u015b\u0007k\u0002\u0002\u015b\u015c",
    "\u0007u\u0002\u0002\u015c\u015d\u0007g\u0002\u0002\u015d\u015e\u0007",
    "e\u0002\u0002\u015e\u015f\u0007q\u0002\u0002\u015f\u0160\u0007p\u0002",
    "\u0002\u0160\u0161\u0007f\u0002\u0002\u0161\u0162\u0007u\u0002\u0002",
    "\u0162j\u0003\u0002\u0002\u0002\u0163\u0164\u0007B\u0002\u0002\u0164",
    "\u0165\t\u0002\u0002\u0002\u0165\u0166\t\u0002\u0002\u0002\u0166\u0167",
    "\t\u0002\u0002\u0002\u0167\u0174\t\u0002\u0002\u0002\u0168\u0169\u0007",
    "/\u0002\u0002\u0169\u016a\t\u0002\u0002\u0002\u016a\u0172\t\u0002\u0002",
    "\u0002\u016b\u016c\u0007/\u0002\u0002\u016c\u016d\t\u0002\u0002\u0002",
    "\u016d\u0170\t\u0002\u0002\u0002\u016e\u016f\u0007V\u0002\u0002\u016f",
    "\u0171\u0005o8\u0002\u0170\u016e\u0003\u0002\u0002\u0002\u0170\u0171",
    "\u0003\u0002\u0002\u0002\u0171\u0173\u0003\u0002\u0002\u0002\u0172\u016b",
    "\u0003\u0002\u0002\u0002\u0172\u0173\u0003\u0002\u0002\u0002\u0173\u0175",
    "\u0003\u0002\u0002\u0002\u0174\u0168\u0003\u0002\u0002\u0002\u0174\u0175",
    "\u0003\u0002\u0002\u0002\u0175\u0177\u0003\u0002\u0002\u0002\u0176\u0178",
    "\u0007\\\u0002\u0002\u0177\u0176\u0003\u0002\u0002\u0002\u0177\u0178",
    "\u0003\u0002\u0002\u0002\u0178l\u0003\u0002\u0002\u0002\u0179\u017a",
    "\u0007B\u0002\u0002\u017a\u017b\u0007V\u0002\u0002\u017b\u017c\u0005",
    "o8\u0002\u017cn\u0003\u0002\u0002\u0002\u017d\u017e\t\u0002\u0002\u0002",
    "\u017e\u018f\t\u0002\u0002\u0002\u017f\u0180\u0007<\u0002\u0002\u0180",
    "\u0181\t\u0002\u0002\u0002\u0181\u018d\t\u0002\u0002\u0002\u0182\u0183",
    "\u0007<\u0002\u0002\u0183\u0184\t\u0002\u0002\u0002\u0184\u018b\t\u0002",
    "\u0002\u0002\u0185\u0187\u00070\u0002\u0002\u0186\u0188\t\u0002\u0002",
    "\u0002\u0187\u0186\u0003\u0002\u0002\u0002\u0188\u0189\u0003\u0002\u0002",
    "\u0002\u0189\u0187\u0003\u0002\u0002\u0002\u0189\u018a\u0003\u0002\u0002",
    "\u0002\u018a\u018c\u0003\u0002\u0002\u0002\u018b\u0185\u0003\u0002\u0002",
    "\u0002\u018b\u018c\u0003\u0002\u0002\u0002\u018c\u018e\u0003\u0002\u0002",
    "\u0002\u018d\u0182\u0003\u0002\u0002\u0002\u018d\u018e\u0003\u0002\u0002",
    "\u0002\u018e\u0190\u0003\u0002\u0002\u0002\u018f\u017f\u0003\u0002\u0002",
    "\u0002\u018f\u0190\u0003\u0002\u0002\u0002\u0190\u0198\u0003\u0002\u0002",
    "\u0002\u0191\u0199\u0007\\\u0002\u0002\u0192\u0193\t\u0003\u0002\u0002",
    "\u0193\u0194\t\u0002\u0002\u0002\u0194\u0195\t\u0002\u0002\u0002\u0195",
    "\u0196\u0007<\u0002\u0002\u0196\u0197\t\u0002\u0002\u0002\u0197\u0199",
    "\t\u0002\u0002\u0002\u0198\u0191\u0003\u0002\u0002\u0002\u0198\u0192",
    "\u0003\u0002\u0002\u0002\u0198\u0199\u0003\u0002\u0002\u0002\u0199p",
    "\u0003\u0002\u0002\u0002\u019a\u019c\t\u0004\u0002\u0002\u019b\u019a",
    "\u0003\u0002\u0002\u0002\u019c\u01a0\u0003\u0002\u0002\u0002\u019d\u019f",
    "\t\u0005\u0002\u0002\u019e\u019d\u0003\u0002\u0002\u0002\u019f\u01a2",
    "\u0003\u0002\u0002\u0002\u01a0\u019e\u0003\u0002\u0002\u0002\u01a0\u01a1",
    "\u0003\u0002\u0002\u0002\u01a1r\u0003\u0002\u0002\u0002\u01a2\u01a0",
    "\u0003\u0002\u0002\u0002\u01a3\u01a8\u0007$\u0002\u0002\u01a4\u01a7",
    "\u0005\u007f@\u0002\u01a5\u01a7\n\u0006\u0002\u0002\u01a6\u01a4\u0003",
    "\u0002\u0002\u0002\u01a6\u01a5\u0003\u0002\u0002\u0002\u01a7\u01aa\u0003",
    "\u0002\u0002\u0002\u01a8\u01a6\u0003\u0002\u0002\u0002\u01a8\u01a9\u0003",
    "\u0002\u0002\u0002\u01a9\u01ab\u0003\u0002\u0002\u0002\u01aa\u01a8\u0003",
    "\u0002\u0002\u0002\u01ab\u01ac\u0007$\u0002\u0002\u01act\u0003\u0002",
    "\u0002\u0002\u01ad\u01b2\u0007)\u0002\u0002\u01ae\u01b1\u0005\u007f",
    "@\u0002\u01af\u01b1\n\u0007\u0002\u0002\u01b0\u01ae\u0003\u0002\u0002",
    "\u0002\u01b0\u01af\u0003\u0002\u0002\u0002\u01b1\u01b4\u0003\u0002\u0002",
    "\u0002\u01b2\u01b0\u0003\u0002\u0002\u0002\u01b2\u01b3\u0003\u0002\u0002",
    "\u0002\u01b3\u01b5\u0003\u0002\u0002\u0002\u01b4\u01b2\u0003\u0002\u0002",
    "\u0002\u01b5\u01b6\u0007)\u0002\u0002\u01b6v\u0003\u0002\u0002\u0002",
    "\u01b7\u01b9\t\u0002\u0002\u0002\u01b8\u01b7\u0003\u0002\u0002\u0002",
    "\u01b9\u01ba\u0003\u0002\u0002\u0002\u01ba\u01b8\u0003\u0002\u0002\u0002",
    "\u01ba\u01bb\u0003\u0002\u0002\u0002\u01bb\u01c2\u0003\u0002\u0002\u0002",
    "\u01bc\u01be\u00070\u0002\u0002\u01bd\u01bf\t\u0002\u0002\u0002\u01be",
    "\u01bd\u0003\u0002\u0002\u0002\u01bf\u01c0\u0003\u0002\u0002\u0002\u01c0",
    "\u01be\u0003\u0002\u0002\u0002\u01c0\u01c1\u0003\u0002\u0002\u0002\u01c1",
    "\u01c3\u0003\u0002\u0002\u0002\u01c2\u01bc\u0003\u0002\u0002\u0002\u01c2",
    "\u01c3\u0003\u0002\u0002\u0002\u01c3x\u0003\u0002\u0002\u0002\u01c4",
    "\u01c6\t\b\u0002\u0002\u01c5\u01c4\u0003\u0002\u0002\u0002\u01c6\u01c7",
    "\u0003\u0002\u0002\u0002\u01c7\u01c5\u0003\u0002\u0002\u0002\u01c7\u01c8",
    "\u0003\u0002\u0002\u0002\u01c8\u01c9\u0003\u0002\u0002\u0002\u01c9\u01ca",
    "\b=\u0002\u0002\u01caz\u0003\u0002\u0002\u0002\u01cb\u01cc\u00071\u0002",
    "\u0002\u01cc\u01cd\u0007,\u0002\u0002\u01cd\u01d1\u0003\u0002\u0002",
    "\u0002\u01ce\u01d0\u000b\u0002\u0002\u0002\u01cf\u01ce\u0003\u0002\u0002",
    "\u0002\u01d0\u01d3\u0003\u0002\u0002\u0002\u01d1\u01d2\u0003\u0002\u0002",
    "\u0002\u01d1\u01cf\u0003\u0002\u0002\u0002\u01d2\u01d4\u0003\u0002\u0002",
    "\u0002\u01d3\u01d1\u0003\u0002\u0002\u0002\u01d4\u01d5\u0007,\u0002",
    "\u0002\u01d5\u01d6\u00071\u0002\u0002\u01d6\u01d7\u0003\u0002\u0002",
    "\u0002\u01d7\u01d8\b>\u0002\u0002\u01d8|\u0003\u0002\u0002\u0002\u01d9",
    "\u01da\u00071\u0002\u0002\u01da\u01db\u00071\u0002\u0002\u01db\u01df",
    "\u0003\u0002\u0002\u0002\u01dc\u01de\n\t\u0002\u0002\u01dd\u01dc\u0003",
    "\u0002\u0002\u0002\u01de\u01e1\u0003\u0002\u0002\u0002\u01df\u01dd\u0003",
    "\u0002\u0002\u0002\u01df\u01e0\u0003\u0002\u0002\u0002\u01e0\u01e2\u0003",
    "\u0002\u0002\u0002\u01e1\u01df\u0003\u0002\u0002\u0002\u01e2\u01e3\b",
    "?\u0002\u0002\u01e3~\u0003\u0002\u0002\u0002\u01e4\u01e7\u0007^\u0002",
    "\u0002\u01e5\u01e8\t\n\u0002\u0002\u01e6\u01e8\u0005\u0081A\u0002\u01e7",
    "\u01e5\u0003\u0002\u0002\u0002\u01e7\u01e6\u0003\u0002\u0002\u0002\u01e8",
    "\u0080\u0003\u0002\u0002\u0002\u01e9\u01ea\u0007w\u0002\u0002\u01ea",
    "\u01eb\u0005\u0083B\u0002\u01eb\u01ec\u0005\u0083B\u0002\u01ec\u01ed",
    "\u0005\u0083B\u0002\u01ed\u01ee\u0005\u0083B\u0002\u01ee\u0082\u0003",
    "\u0002\u0002\u0002\u01ef\u01f0\t\u000b\u0002\u0002\u01f0\u0084\u0003",
    "\u0002\u0002\u0002\u001a\u0002\u0170\u0172\u0174\u0177\u0189\u018b\u018d",
    "\u018f\u0198\u019b\u019e\u01a0\u01a6\u01a8\u01b0\u01b2\u01ba\u01c0\u01c2",
    "\u01c7\u01d1\u01df\u01e7\u0003\u0002\u0003\u0002"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

function FHIRPathLexer(input) {
	antlr4.Lexer.call(this, input);
    this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.PredictionContextCache());
    return this;
}

FHIRPathLexer.prototype = Object.create(antlr4.Lexer.prototype);
FHIRPathLexer.prototype.constructor = FHIRPathLexer;

Object.defineProperty(FHIRPathLexer.prototype, "atn", {
        get : function() {
                return atn;
        }
});

FHIRPathLexer.EOF = antlr4.Token.EOF;
FHIRPathLexer.T__0 = 1;
FHIRPathLexer.T__1 = 2;
FHIRPathLexer.T__2 = 3;
FHIRPathLexer.T__3 = 4;
FHIRPathLexer.T__4 = 5;
FHIRPathLexer.T__5 = 6;
FHIRPathLexer.T__6 = 7;
FHIRPathLexer.T__7 = 8;
FHIRPathLexer.T__8 = 9;
FHIRPathLexer.T__9 = 10;
FHIRPathLexer.T__10 = 11;
FHIRPathLexer.T__11 = 12;
FHIRPathLexer.T__12 = 13;
FHIRPathLexer.T__13 = 14;
FHIRPathLexer.T__14 = 15;
FHIRPathLexer.T__15 = 16;
FHIRPathLexer.T__16 = 17;
FHIRPathLexer.T__17 = 18;
FHIRPathLexer.T__18 = 19;
FHIRPathLexer.T__19 = 20;
FHIRPathLexer.T__20 = 21;
FHIRPathLexer.T__21 = 22;
FHIRPathLexer.T__22 = 23;
FHIRPathLexer.T__23 = 24;
FHIRPathLexer.T__24 = 25;
FHIRPathLexer.T__25 = 26;
FHIRPathLexer.T__26 = 27;
FHIRPathLexer.T__27 = 28;
FHIRPathLexer.T__28 = 29;
FHIRPathLexer.T__29 = 30;
FHIRPathLexer.T__30 = 31;
FHIRPathLexer.T__31 = 32;
FHIRPathLexer.T__32 = 33;
FHIRPathLexer.T__33 = 34;
FHIRPathLexer.T__34 = 35;
FHIRPathLexer.T__35 = 36;
FHIRPathLexer.T__36 = 37;
FHIRPathLexer.T__37 = 38;
FHIRPathLexer.T__38 = 39;
FHIRPathLexer.T__39 = 40;
FHIRPathLexer.T__40 = 41;
FHIRPathLexer.T__41 = 42;
FHIRPathLexer.T__42 = 43;
FHIRPathLexer.T__43 = 44;
FHIRPathLexer.T__44 = 45;
FHIRPathLexer.T__45 = 46;
FHIRPathLexer.T__46 = 47;
FHIRPathLexer.T__47 = 48;
FHIRPathLexer.T__48 = 49;
FHIRPathLexer.T__49 = 50;
FHIRPathLexer.T__50 = 51;
FHIRPathLexer.T__51 = 52;
FHIRPathLexer.DATETIME = 53;
FHIRPathLexer.TIME = 54;
FHIRPathLexer.IDENTIFIER = 55;
FHIRPathLexer.QUOTEDIDENTIFIER = 56;
FHIRPathLexer.STRING = 57;
FHIRPathLexer.NUMBER = 58;
FHIRPathLexer.WS = 59;
FHIRPathLexer.COMMENT = 60;
FHIRPathLexer.LINE_COMMENT = 61;

FHIRPathLexer.prototype.channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];

FHIRPathLexer.prototype.modeNames = [ "DEFAULT_MODE" ];

FHIRPathLexer.prototype.literalNames = [ null, "'.'", "'['", "']'", "'+'", 
                                         "'-'", "'*'", "'/'", "'div'", "'mod'", 
                                         "'&'", "'|'", "'<='", "'<'", "'>'", 
                                         "'>='", "'is'", "'as'", "'='", 
                                         "'~'", "'!='", "'!~'", "'in'", 
                                         "'contains'", "'and'", "'or'", 
                                         "'xor'", "'implies'", "'('", "')'", 
                                         "'{'", "'}'", "'true'", "'false'", 
                                         "'%'", "'$this'", "','", "'year'", 
                                         "'month'", "'week'", "'day'", "'hour'", 
                                         "'minute'", "'second'", "'millisecond'", 
                                         "'years'", "'months'", "'weeks'", 
                                         "'days'", "'hours'", "'minutes'", 
                                         "'seconds'", "'milliseconds'" ];

FHIRPathLexer.prototype.symbolicNames = [ null, null, null, null, null, 
                                          null, null, null, null, null, 
                                          null, null, null, null, null, 
                                          null, null, null, null, null, 
                                          null, null, null, null, null, 
                                          null, null, null, null, null, 
                                          null, null, null, null, null, 
                                          null, null, null, null, null, 
                                          null, null, null, null, null, 
                                          null, null, null, null, null, 
                                          null, null, null, "DATETIME", 
                                          "TIME", "IDENTIFIER", "QUOTEDIDENTIFIER", 
                                          "STRING", "NUMBER", "WS", "COMMENT", 
                                          "LINE_COMMENT" ];

FHIRPathLexer.prototype.ruleNames = [ "T__0", "T__1", "T__2", "T__3", "T__4", 
                                      "T__5", "T__6", "T__7", "T__8", "T__9", 
                                      "T__10", "T__11", "T__12", "T__13", 
                                      "T__14", "T__15", "T__16", "T__17", 
                                      "T__18", "T__19", "T__20", "T__21", 
                                      "T__22", "T__23", "T__24", "T__25", 
                                      "T__26", "T__27", "T__28", "T__29", 
                                      "T__30", "T__31", "T__32", "T__33", 
                                      "T__34", "T__35", "T__36", "T__37", 
                                      "T__38", "T__39", "T__40", "T__41", 
                                      "T__42", "T__43", "T__44", "T__45", 
                                      "T__46", "T__47", "T__48", "T__49", 
                                      "T__50", "T__51", "DATETIME", "TIME", 
                                      "TIMEFORMAT", "IDENTIFIER", "QUOTEDIDENTIFIER", 
                                      "STRING", "NUMBER", "WS", "COMMENT", 
                                      "LINE_COMMENT", "ESC", "UNICODE", 
                                      "HEX" ];

FHIRPathLexer.prototype.grammarFileName = "FHIRPath.g4";



exports.FHIRPathLexer = FHIRPathLexer;

